/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Text_To_SpeechInputs */

const en_text_to_speech = /** @type {(inputs: Text_To_SpeechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text To Speech`)
};

const fr_text_to_speech = /** @type {(inputs: Text_To_SpeechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synthèse vocale`)
};

const de_text_to_speech = /** @type {(inputs: Text_To_SpeechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text-zu-Sprache-Konvertierung`)
};

const it_text_to_speech = /** @type {(inputs: Text_To_SpeechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo in voce`)
};

const ru_text_to_speech = /** @type {(inputs: Text_To_SpeechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преобразование текста в речь`)
};

const es_text_to_speech = /** @type {(inputs: Text_To_SpeechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto a voz`)
};

const zh_cn2_text_to_speech = /** @type {(inputs: Text_To_SpeechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本转语音`)
};

const ja_text_to_speech = /** @type {(inputs: Text_To_SpeechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキスト読み上げ`)
};

const hi_text_to_speech = /** @type {(inputs: Text_To_SpeechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भाषण के पाठ`)
};

const pt_pt2_text_to_speech = /** @type {(inputs: Text_To_SpeechInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto para fala`)
};

/**
* | output |
* | --- |
* | "Text To Speech" |
*
* @param {Text_To_SpeechInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const text_to_speech = /** @type {((inputs?: Text_To_SpeechInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Text_To_SpeechInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_text_to_speech(inputs)
	if (locale === "de") return de_text_to_speech(inputs)
	if (locale === "it") return it_text_to_speech(inputs)
	if (locale === "ru") return ru_text_to_speech(inputs)
	if (locale === "es") return es_text_to_speech(inputs)
	if (locale === "zh-CN") return zh_cn2_text_to_speech(inputs)
	if (locale === "ja") return ja_text_to_speech(inputs)
	if (locale === "hi") return hi_text_to_speech(inputs)
	if (locale === "pt-PT") return pt_pt2_text_to_speech(inputs)
	return en_text_to_speech(inputs)
});